import React from 'react';
import styled from 'styled-components';
import Sphere3D from './Sphere3D';

interface PortalProps {
  onPortalEnter: () => void;
}

const PortalContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background: radial-gradient(circle at center, rgba(0, 109, 91, 0.2) 0%, rgba(0, 0, 0, 0.95) 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
`;

const Portal: React.FC<PortalProps> = ({ onPortalEnter }) => {
  return (
    <PortalContainer>
      <Sphere3D onEnter={onPortalEnter} />
    </PortalContainer>
  );
};

export default Portal;
